const ABProcessTaskUserExternalCore = require("../../../core/process/tasks/ABProcessTaskUserExternalCore");
module.exports = class ABProcessTaskUserExternal extends (
   ABProcessTaskUserExternalCore
) {};
